export default {
    topNav: {
        size: 'Tamaño',
        language: 'Idioma',
        refreshCache: 'Actualizar caché {{org}}',
    },
    topTicker: {
        ar: 'AR',
        val: 'VAL',
        rj: 'RJ',
        trash: 'BASURA',
        lastFresh: 'ÚLTIMO NUEVO',
        lastFreshFromMarketing: 'ÚLTIMO NUEVO DESDE MARKETING',
    },
    sideNav: {
        home: 'Inicio',
        signOut: 'Cerrar sesión',
        cmdc: 'CMDC',
        realTime: 'Tiempo real',
        statisticReport: 'Informe estadístico',
        logistic: 'Logística',
        history: 'Historial',
        wallboard: 'Panel en vivo',
        dailyPubsPriority: 'Prioridad diaria de publicistas',
        campaignOverview: 'Resumen de campaña',
        campaignOverviewV2: 'Resumen de campaña V2',
        campaignOverviewV3: 'Resumen de campaña V3',
        campaignUpdated: 'Campaña actualizada',
        publishPerformance: 'Rendimiento de publicación',
        publishPerformance2: 'Rendimiento de publicación 2',
        networkPerformance: 'Rendimiento de red',
        teamPerformance: 'Rendimiento del equipo',
        teamCpPerformance: 'Rendimiento equipo-CP',
        prodTeamPerf: 'Rendimiento equipo prod.',
        agentToday: 'Agente hoy',
        agentMtd: 'Agente MTD',
        agentChartToday: 'Gráfico agente hoy',
        agentChartMtd: 'Gráfico agente MTD',
        leadDistToday: 'Distrib. prospectos hoy',
        leadDistTodayV2: 'Distrib. prospectos hoy V2',
        leadDistShift: 'Distrib. prospectos turno',
        leadDistMtd: 'Distrib. prospectos MTD',
        leadDistChartToday: 'Gráfico distrib. prospectos hoy',
        leadDistChartMtd: 'Gráfico distrib. prospectos MTD',
        teamPerfMtd: 'Rend. equipo (MTD)',
        teamPerfAll: 'Rend. equipo (todos)',
        teamPerfNew: 'Rend. equipo (nuevos)',
        teamCpPerfAll: 'Rend. equipo CP (todos)',
        teamCpPerfNew: 'Rend. equipo CP (nuevos)',
        rescueSummary: 'Resumen de rescate',
        rescueCall: 'Llamada de rescate',
        agentAll: 'Agente (todos)',
        dailyStatistic: 'Estadística diaria',
        dailyStatisticNew: 'Estadística diaria (nueva)',
        fulfillmentStock: 'Stock de fulfillment',
        logDo: 'Registro DO',
    },
    common: {
        loading: 'Cargando...',
        confirmApi: '¿Confirmar {{name}}?',
        apiSuccess: '{{name}} correcto.',
        apiFail: '{{name}} falló.',
        close: 'Cerrar',
        toggleMenu: 'Alternar menú',
        next: 'Siguiente',
        previous: 'Anterior',
        zoomIn: 'Ampliar',
        zoomOut: 'Reducir',
        toggleSection: 'Alternar sección',
        expandAll: 'Expandir todo',
        collapseAll: 'Contraer todo',
        loadMore: 'Cargar más',
        todo: 'PENDIENTE',
    },
    login: {
        title: 'Iniciar sesión',
        username: 'Usuario',
        password: 'Contraseña',
        passwordPlaceholder: 'Ingrese contraseña',
        submit: 'Iniciar sesión',
        loginFailed: 'Error de inicio de sesión.',
        invalidDomain: 'Dominio de correo inválido.',
        needAccount: '¿Necesita una cuenta? ¡Regístrese!',
        copyright: 'Copyright © Su sitio web 2020',
        privacyPolicy: 'Política de privacidad',
        termsConditions: 'Términos y condiciones',
    },
    bdReport: {
        geo: 'Geo',
        affiliate: 'Afiliado',
        all: 'Todos',
        uploadDatasource: 'Subir origen de datos',
        metrics: {
            cpa: 'CPA',
            cpl: 'CPL',
            ar: 'AR',
            cv: 'CV',
        },
        columns: {
            no: 'N.º',
            affId: 'ID afiliado',
            cpaPayout: 'Pago CPA',
            cpaRevenue: 'Ingreso CPA',
            cplPayout: 'Pago CPL',
            cplRevenue: 'Ingreso CPL',
        },
    },
    hsReport: {
        campaignName: 'Nombre de campaña',
        batchId: 'ID de lote',
        datePlaceholder: 'aaaa-mm-dd',
        search: 'Buscar',
        dateFrom: 'Fecha desde',
        dateTo: 'Fecha hasta',
        topAgentsFresh: 'Top {{count}} agentes (nuevo)',
        topAgentsResell: 'Top {{count}} agentes (reventa)',
        columns: {
            campaign: 'Campaña',
            leads: 'Prospectos',
            new: 'Nuevo',
            aov: 'AOV',
            ar: 'AR',
            arQa: 'AR-QA',
            ear: 'E-AR',
            uncall: 'No Contesta',
            trash: 'Basura',
            rejected: 'Rechazado',
            callback: 'Devolución de Llamada',
            urgent: 'Urgente',
            agent: 'Agente',
            sales: 'Ventas',
            approved: 'Aprobado',
        },
    },
    statisticReport: {
        dateFrom: 'Fecha desde',
        dateTo: 'Fecha hasta',
        date: 'Fecha',
        createdDateFrom: 'Fecha creación desde',
        createdDateTo: 'Fecha creación hasta',
        modifiedDateFrom: 'Fecha modificación desde',
        modifiedDateTo: 'Fecha modificación hasta',
        search: 'Buscar',
        export: 'Exportar',
        keyword: 'Palabra clave',
        fresh: 'Nuevo',
        resell: 'Reventa',
        campaign: 'Campaña',
        leadsCountedByCreated: 'Los prospectos de este informe se contarán por fecha de creación',
        leadsCountedByModified: 'Los prospectos de este informe se contarán por fecha de modificación',
        leadsCountedByCreatedShort: 'Los prospectos de este informe se contarán por fecha de creación',
        leadsCountedByModifiedShort: 'Los prospectos de este informe se contarán por fecha de modificación',
        freshCampaign: 'Campaña nueva',
        resellCampaign: 'Campaña Reventa',
        allCampaign: 'Todas las campañas',
        viewByCreatedDate: 'Ver por fecha de creación',
        viewByModifiedDate: 'Ver por fecha de modificación',
        lastUpdatedAt: 'Última actualización: {{time}}',
        firstAttempt: {
            achieved: 'LOGRADO',
            failed: 'FALLIDO',
            error: 'error',
        },
    },
    cmdc: {
        fresh: 'Nuevo',
        resell: 'Reventa',
        all: 'Todos',
        search: 'Buscar',
        cache: 'Caché {{time}}',
        filter: 'Filtrar',
        apply: 'Aplicar',
        close: 'Cerrar',
        campaignSummary: 'Resumen de campaña',
        view: 'Vista',
        dateFrom: 'Fecha desde',
        dateTo: 'Fecha hasta',
        status: 'Estado',
        summaryView: 'Vista resumen',
        attemptView: 'Vista de intentos',
        total: 'TOTAL',
        campaign: 'Campaña',
        team: 'Equipo',
        index: 'Índice',
        value: 'Valor',
        summary: 'Resumen',
        time: 'Tiempo',
        latest: 'Último',
        avgAttempts: 'Intentos prom.',
        kpis: 'KPIs',
        longest: 'Más largo',
        liveAgents: 'Agentes en vivo',
        staffed: 'Personal',
        latestUpd: 'Últ. actualización',
        agentsOf: '# de agentes',
        skillLevel: 'SL {{level}}',
        resellMarker: '(M)',
        agentStatus: {
            assigned: 'Asignado',
            onCall: 'En llamada',
            wrapUp: 'Cierre',
            available: 'Disponible',
            break: 'Descanso',
            unavailable: 'No disponible',
            busy: 'Ocupado',
            logout: 'Cierre de sesión',
        },
        columns: {
            campaign: 'Campaña',
            leads: 'Prospectos',
            new: 'Nuevo',
            aov: 'AOV',
            ar: 'AR',
            avgAttempt: 'Intento prom.',
            approved: 'Aprobado',
            uncall: 'No Contesta',
            trash: 'Basura',
            rejected: 'Rechazado',
            callback: 'Devolución de Llamada',
            urgent: 'Urgente',
            agent: 'Agente',
            bestMatchRate: 'Tasa mejor coincidencia',
            longestWaitTime: 'Tiempo espera más largo',
            attempts: 'Intentos',
            avg: 'PROM',
            total: 'Total',
        },
    },
    report: {
        download: 'Descargar',
        noData: 'Sin datos',
        statusMapping: 'mapeo de estado',
        topAgentsFresh: 'Top {{count}} agentes (nuevo)',
        topAgentsResell: 'Top {{count}} agentes (reventa)',
        freshCampaignHyphen: 'Campaña-Nueva',
        resellCampaignHyphen: 'Campaña - Reventa',
        hierarchyTeam: 'Equipo',
        hierarchyCampaign: 'Campaña',
        hierarchyAgent: 'Agente',
        priorityOn: 'PRIORIDAD {{date}}',
        source: 'Origen',
        ticketCode: 'Código de ticket',
        createDate: 'Fecha de creación',
        payload: 'Payload',
        campaignView: 'Vista campaña',
        agentView: 'Vista agente',
        leadPlanBySalesCampaign: 'PLAN DE PROSPECTOS POR CAMPAÑA DE VENTAS',
        hide: 'Ocultar',
        noTeam: 'No datos',
        marginRules: 'Reglas de margen',
        reload: 'Recargar',
        marginReloadConfirm: '¿Confirmar recarga de la configuración de margen de Google?',
        range: 'Rango',
        chart: {
            delivered: 'Entregado',
            so: 'SO',
            approved: 'Aprobado',
            leads: 'Prospectos',
        },
        rescueStatus: {
            pending: '9-pendiente',
            new: '1-nuevo',
            intransit: '2-en tránsito',
            delivering: '3-Entregando',
            returning: '4-devolución',
            unknown: '0-desconocido',
        },
        metrics: {
            uncalledShort: 'u',
            rejectedShort: 'r',
            rejectedRj: 'rj',
            callbackShort: 'rl',
            urgentShort: 'ur',
            attemptShort: 'at',
            eAr: 'eAr',
            aov: 'aov',
            arMrp: 'AR_MRP',
            aovMrp: 'AOV_MRP',
            mrp: 'MRP:',
            cplTag: 'CPL',
        },
        alt: {
            diamond: 'Diamante',
        },
        hierarchyGroupAria: 'Grupo jerárquico',
        campaignOverviewV2: {
            reject: 'Rechazado',
            closed: 'Cerrado',
            uncall: 'No Contesta',
            callback: 'Devolución de Llamada',
            approved: 'Aprobado',
            total: 'Total',
            attempt12: '#1-2',
            attempt35: '#3-5',
            attempt68: '#6-8',
            attempt8plus: '#8+',
            abbrevP: 'P',
            abbrevC: 'C',
            abbrevNp: 'NP',
            abbrevN: 'N',
            abbrevV: 'V',
            abbrevD: 'D',
        },
        cards: {
            totalSales: 'Ventas totales',
            totalSalesCap: 'Ventas totales',
            totalOrders: 'Pedidos totales',
            todayOrders: 'Pedidos hoy',
            mtdSales: 'Ventas MTD',
            mtdDailySalesF: 'Ventas diarias MTD (F)',
            mtdDailySalesR: 'Ventas diarias MTD (R)',
            mtdDailySales: 'Ventas diarias MTD',
            totalSalesF: 'Ventas totales (F)',
            totalSalesR: 'Ventas totales (R)',
            freshOrders: 'Pedidos nuevos',
            resellOrders: 'Pedidos de reventa',
            todayAovF: 'AOV hoy (F)',
            todayAovR: 'AOV hoy (R)',
            mtdSalesF: 'Ventas MTD (F)',
            mtdSalesR: 'Ventas MTD (R)',
            freshLeads: 'Prospectos nuevos',
            resellLeads: 'Prospectos de reventa',
            freshToday: 'Nuevo hoy',
            freshYesterday: 'Nuevo ayer',
            approve: 'Aprobar',
            freshCampaigns: 'Campañas nuevas',
        },
        fulfillment: {
            product: 'Producto',
            actualStock: 'Stock real',
            reservedStock: 'Stock reservado',
            sellableStock: 'Stock vendible',
        },
        dailyPubs: {
            priority: 'Prioridad',
            aff: 'Aff',
            offer: 'Oferta',
            salesCamp: 'Campaña ventas',
            sub: 'Sub',
            leadD1: 'Prospecto d-1',
            arQa: 'AR QA',
            arQc: 'AR QC',
            tr: 'TR',
            arMrp: 'AR MRP',
            leadMrp: 'Prospecto MRP',
            plan: 'Plan',
            noteForSales: 'Nota para ventas',
        },
        columns: {
            name: 'Nombre',
            sale: 'Venta',
            hour: 'Hora',
            team: 'Equipo',
            sl: 'SL',
            fcr: 'FCR',
            ttt: 'TTT',
            pub: 'Pub',
            no: 'N.º',
            validated: 'Validado',
            leadMrp: 'Prospecto MRP',
            arQc: 'AR-QC',
            arQaUnderscore: 'AR_QA',
            deliver: 'Entrega',
            dsale: 'D-Venta',
            dr: 'DR',
            daov: 'D-AOV',
            ucAtmp: 'UC_ATMP',
            ucRing: 'UC_Ring',
            att: 'ATT',
            calls: 'Llamadas',
            odcb: 'ODCB',
            doId: 'ID DO',
            trackingCode: 'Código seguimiento',
            ffm: 'FFM',
            lm: 'LM',
            packageName: 'Nombre paquete',
            amount: 'Monto',
            customer: 'Cliente',
            phone: 'Teléfono',
            province: 'Provincia',
            create: 'Crear',
            date: 'Fecha',
            status: 'Estado',
            reason: 'Motivo',
            day: 'día',
            latestLead: 'Último prospecto',
            shift: 'Turno',
        },
    },
}
